// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"462":"e3dc6e87e4494ea6","609":"a596a6a5aae05466"}[chunkId] + ".js";
};